import { Component, inject, input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatSidebarService, ChatSidebarType, ChatSidebarConfig } from 'src/app/features/chat/services/chat-sidebar.service';
import { TooltipModule } from 'primeng/tooltip';
import { AssetUrlPipe } from 'src/app/@shared/pipes/asset-url.pipe';
import { CustomFloatingComponentComponent } from '../custom-floating-component/custom-floating-component.component';
import { AuthenticationService } from 'src/app/@core/services/authentication.service';


@Component({
    selector: 'app-chat-bubble',
    standalone: true,
    imports: [CommonModule, TooltipModule, AssetUrlPipe, CustomFloatingComponentComponent],
    templateUrl: './chat-bubble.component.html',
})
export class ChatBubbleComponent implements OnInit, OnDestroy {
    chatType = input.required<ChatSidebarType>();
    chatConfig = input.required<ChatSidebarConfig>();

    private chatSidebarService = inject(ChatSidebarService);
    private authService = inject(AuthenticationService);

    ngOnInit() {
        this.chatSidebarService.registerBubble(this.chatType(), this.chatConfig());
    }

    ngOnDestroy() {
        this.chatSidebarService.clearBubble();
    }

    /**
     * Set to true when a drag gesture just ended so the click event that fires
     * immediately after a CDK drag-release does NOT open the chat panel.
     * Cleared on the very next click.
     */
    wasDragging = false;

    get isOpen() {
        return this.chatSidebarService.isOpen;
    }

    /** Called by (dragReleased) on the floating wrapper — marks that last action was a drag. */
    onDragReleased(): void {
        this.wasDragging = true;
    }

    get isBobEnabled(): boolean {
        const settings = this.authService.getUser()?.agentModeSettings;
        if (!settings) return true;
        return settings.askMode || settings.agentMode;
    }

    /** Opens the chat panel, unless the click was the synthetic one after a drag-release. */
    onBubbleClick(): void {
        if (this.wasDragging) {
            this.wasDragging = false;
            return;
        }
        this.chatSidebarService.open(this.chatType(), this.chatConfig());
    }
}
